import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const STATUS_META = {
  upcoming: ["Upcoming", "bg-white/10 text-white/60"],
  in_progress: ["In progress", "bg-[#c9a961]/25 text-[#e8d29a]"],
  complete: ["Complete", "bg-[#2f7d5b]/25 text-[#8fd6b4]"],
};
const API = process.env.REACT_APP_BACKEND_URL;

export default function JobProgressPublic() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/public/job-progress/${token}`)
      .then((r) => setData(r.data))
      .catch(() => setErr(true));
  }, [token]);

  if (err) return <div className="min-h-screen bg-[#12211f] flex items-center justify-center text-white/70 px-6 text-center">This progress link is unavailable or has been turned off.</div>;
  if (!data) return <div className="min-h-screen bg-[#12211f] flex items-center justify-center text-white/50">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#12211f] text-white" data-testid="public-job-progress">
      <div className="max-w-3xl mx-auto px-5 py-10">
        <div className="text-[11px] uppercase tracking-[0.24em] text-[#c9a961] mb-2">{data.business_name || "Project"} · Progress</div>
        <h1 className="font-head text-3xl sm:text-4xl">{data.job_name}</h1>
        <div className="mt-1 text-white/55 text-sm">{data.client_name ? `Prepared for ${data.client_name}` : ""}{data.status ? ` · ${data.status}` : ""}</div>
        {typeof data.pct_complete === "number" && (
          <div className="mt-4 h-2 w-full rounded-full bg-white/10 overflow-hidden"><div className="h-full rounded-full bg-[#c9a961]" style={{ width: `${Math.max(0, Math.min(100, data.pct_complete))}%` }} /></div>
        )}

        <div className="mt-8 space-y-6">
          {data.stages.length === 0 && <div className="text-white/40 text-center py-10">No stages posted yet — check back soon.</div>}
          {data.stages.map((s, idx) => {
            const [label, cls] = STATUS_META[s.status] || STATUS_META.upcoming;
            return (
              <div key={s.id} className="relative pl-6 border-l border-white/10" data-testid={`public-stage-${s.id}`}>
                <div className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-[#c9a961]" />
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[10px] font-semibold text-[#c9a961]">Stage {idx + 1}</span>
                  <span className="font-semibold text-lg">{s.title}</span>
                  <span className={`rounded-full px-2 py-0.5 text-[9px] uppercase tracking-wide ${cls}`}>{label}</span>
                </div>
                {s.date && <div className="text-[11px] text-white/45 mt-0.5">{s.date}</div>}
                {s.note && <p className="text-white/75 text-sm mt-1.5">{s.note}</p>}
                {s.photos.length > 0 && (
                  <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {s.photos.map((p) => (
                      <a key={p.id} href={`${API}${p.url}`} target="_blank" rel="noreferrer" className="block aspect-square rounded-lg overflow-hidden bg-white/5">
                        <img src={`${API}${p.url}`} alt={s.title} className="h-full w-full object-cover hover:scale-105 transition-transform duration-300" />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="mt-10 text-center text-[11px] text-white/35">Live project updates powered by {data.business_name || "Elevare"}.</div>
      </div>
    </div>
  );
}
